"use strict";

angular.module("preventUnsavedChanges")
.directive("preventUnsavedChanges", function($state, PreventUnsavedChangesService) {
    return {
        scope: {
            preventUnsavedChanges: "<",
            unsavedMessage: "@"
        },
        restrict: "A",
        link: function(scope, elem) {
            var allowUnsavedChanges = false;

            scope.$on("$stateChangeStart", function(event, toState, toParams) {

                if (!scope.preventUnsavedChanges || allowUnsavedChanges)
                    return;

                event.preventDefault();
                PreventUnsavedChangesService.openModal(scope.unsavedMessage)
                .then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function(confirm) {
                        modal.element.remove();
                        if (confirm) {
                            allowUnsavedChanges = true;
                            $state.go(toState, toParams);
                        }
                    });
                });

            });

            scope.$on("onBeforeUnload", function(e, confirmation) {
                if (!scope.preventUnsavedChanges || allowUnsavedChanges)
                    return;

                confirmation.message = scope.unsavedMessage;
                e.preventDefault();
            });

        }
    }
})
.run(function($window, $rootScope) {
    $window.onbeforeunload = function(e) {
        var confirmation = {};
        var event = $rootScope.$broadcast("onBeforeUnload", confirmation);
        if (event.defaultPrevented)
            return confirmation.message;
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/prevent-unsaved-changes/prevent-unsaved-changes.directive.js
// module id = 341
// module chunks = 0